module.exports = __webpack_public_path__ + "static/media/Aurella-01.baffaa7d.svg";